import React, {useEffect, useState} from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import {withTranslation} from 'react-i18next';
import * as appImages from "assets/images/apps";

const AppsDropdown = () => {
  const [openApps, setOpenApps] = useState(false);
  const [selectedApp, setSelectedApp] = useState("");

  useEffect(() => {
    const currentApp = window.location.pathname.split('/')[1];
    setSelectedApp(currentApp);
  }, []);


  const toggle = () => {
    setOpenApps(!openApps);
  };

  function renderAppItem() {
    const apps: any[] = appImages.images;
    const list: any[] = [];
    apps.forEach((app) => {
      list.push(
        <div className="col">
          <a
            className={`dropdown-icon-item ${selectedApp === app.name ? 'is-active' : ''}`}
            href={`/${app.name}`}
          >
            <img src={app.src} alt={app.title} />
            <span>{app.title}</span>
          </a>
        </div>
      );
    })

    return (<div className={"row g-0"}>{list}</div>)
  }

  return (
    <React.Fragment>
      <Dropdown isOpen={openApps} toggle={toggle} className={"dxg-dropdown"}>
        <DropdownToggle
          className={`btn`}
          id="page-header-user-dropdown"
          tag="button"
        >
          <div>
            <svg className={"top-nav-btn"} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M27 4.5H17.5C17.225 4.5 17 4.725 17 5V14.5C17 14.775 17.225 15 17.5 15H27C27.275 15 27.5 14.775 27.5 14.5V5C27.5 4.725 27.275 4.5 27 4.5ZM27 17H17.5C17.225 17 17 17.225 17 17.5V27C17 27.275 17.225 27.5 17.5 27.5H27C27.275 27.5 27.5 27.275 27.5 27V17.5C27.5 17.225 27.275 17 27 17ZM14.5 4.5H5C4.725 4.5 4.5 4.725 4.5 5V14.5C4.5 14.775 4.725 15 5 15H14.5C14.775 15 15 14.775 15 14.5V5C15 4.725 14.775 4.5 14.5 4.5ZM14.5 17H5C4.725 17 4.5 17.225 4.5 17.5V27C4.5 27.275 4.725 27.5 5 27.5H14.5C14.775 27.5 15 27.275 15 27V17.5C15 17.225 14.775 17 14.5 17Z" fill="#00AEEF"/>
            </svg>
          </div>
        </DropdownToggle>
        <DropdownMenu
          className={`dropdown-menu-end p-l--xxs dropdown__list-item dropdown__list-item_apps`}
        >
          <h4>Tất cả các phân hệ</h4>
          <div className="app-list">
            {renderAppItem()}
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(AppsDropdown);
